namespace $.$$ {
	export class $shm_hitalama_quick2_reorder extends $.$shm_hitalama_quick2_reorder {
		@ $mol_mem
		buttons() { return this.ids().map( id => this.Drag( id ) ) }

		order_start( id: string, event?: PointerEvent ) {
			this.gesture_moved( id, false )
			return event ?? null
		}

		order_end( id: string, event?: PointerEvent ) {
			const offset = this.item_offset( id )
			this.drag_x( id, this.vertical() ? 0 : offset )
			this.drag_y( id, this.vertical() ? offset : 0 )
			return event ?? null
		}

		button_checked( id: string, next?: boolean ) {
			return this.checked( id, next !== undefined && this.gesture_moved( id ) ? undefined : next )
		}

		item_extent( id: string ) {
			const rect = this.Button( id ).view_rect()
			return ( this.vertical() ? rect?.height : rect?.width ) ?? 48
		}

		item_offset( id: string ) {
			const ids = this.ids()
			return ids.slice( 0, ids.indexOf( id ) ).reduce( ( sum, item ) => sum + this.item_extent( item ), 0 )
		}

		panel_extent() { return this.ids().reduce( ( sum, id ) => sum + this.item_extent( id ), 0 ) }
		panel_width() { return this.vertical() ? '3rem' : `${ this.panel_extent() }px` }
		panel_height() { return this.vertical() ? `${ this.panel_extent() }px` : '2.5rem' }

		@ $mol_mem_key
		drag_x( id: string, next?: number ): number {
			return this.vertical() ? 0 : this.drag_position( id, next )
		}

		@ $mol_mem_key
		drag_y( id: string, next?: number ): number {
			return this.vertical() ? this.drag_position( id, next ) : 0
		}

		drag_position( id: string, next?: number ) {
			const previous = this.item_offset( id )
			if( next === undefined || !this.order_dragged( id ) ) return previous
			if( Math.abs( next - previous ) > 4 ) this.gesture_moved( id, true )
			const ids = this.ids().filter( item => item !== id )
			let offset = 0
			let index = 0
			for( const item of ids ) {
				const extent = this.item_extent( item )
				if( next < offset + extent / 2 ) break
				offset += extent
				index++
			}
			ids.splice( index, 0, id )
			const previous_ids = this.ids()
			if( ids.some( ( item, index ) => item !== previous_ids[index] ) ) this.ids( ids )
			return next
		}
	}
}
